// src/components/store/sections/weekly-banner/WeeklyBannerV88CathedralarchCrimsonRose.tsx
"use client";

import React from "react";
import DynamicWeeklyBannerVariant from "./DynamicWeeklyBannerVariant";

export default function WeeklyBannerV88CathedralarchCrimsonRose(props: any) {
  return (
    <DynamicWeeklyBannerVariant
      variantNumber={88}
      archKey="cathedral_arch"
      archLabel="Cathedral Arch Promo"
      palName="CrimsonRose"
      grad="from-rose-500 via-pink-600 to-red-600"
      lightBg="bg-rose-50"
      textCol="text-rose-700"
      borderCol="border-rose-200"
      {...props}
    />
  );
}
